import {
  View,
  Text,
  StyleSheet,
  ImageBackground,
  Platform,
  ScrollView,
  SafeAreaView,
} from "react-native";
import AppLoading from "expo-app-loading";
import { useFonts, Limelight_400Regular } from "@expo-google-fonts/limelight";

// const renew= ()=>{
//   if(Platform.OS==='web'){
//     require("../../assets/new.jpg");
//   }else{
//     require("../../assets/darkMak.jpg");
//   }
// }
const NewYork = Platform.OS==='web'?require("../../assets/darkMak.jpg"):require("../../assets/new.jpg")
import disc from "@jsamr/counter-style/presets/disc";
import MarkedList from "@jsamr/react-native-li";

export default function Experience() {
  let [fontsLoaded] = useFonts({
    Limelight_400Regular,
  });
  if (!fontsLoaded) {
    return <AppLoading />;
  }
  return (
    <SafeAreaView style={styles.container}>
      <ImageBackground source={NewYork} resizeMode="cover" style={styles.image}>
        <ScrollView>
        <Text style={styles.p1}> Experience</Text>
        <View style={styles.experienceWrapper}>
          <Text style={styles.paragraph2}>ALPHAWORKS/Oakland, CA</Text>
          <Text style={styles.paragraph1}>REACT-NATIVE APPRENTICE</Text>
          <Text style={styles.paragraph3}>September 2021 - present</Text>
        </View>
        <Text style={styles.paragraph4}>
          {`Work on a variety of relevant projects under the supervision of experienced technical leads to gain valuable real world practical experience. Build responsive website using:

            `}
          <ScrollView style={styles.scrollView}>
            <MarkedList counterRenderer={disc}>
              {[...Array(1).keys()].map((index) => (
                <Text
                  key={index}
                  style={{
                    flexShrink: 1,
                    color: "#F2D379",
                    width: Platform.OS === "web" ? 300 : 250,
                  }}
                >
                  React
                </Text>
              ))}
            </MarkedList>
            <MarkedList counterRenderer={disc}>
              {[...Array(1).keys()].map((index) => (
                <Text
                  key={index}
                  style={{
                    flexShrink: 1,
                    color: "#F2D379",
                    width: Platform.OS === "web" ? 300 : 250,
                  }}
                >
                  ReactNative
                </Text>
              ))}
            </MarkedList>
            <MarkedList counterRenderer={disc}>
              {[...Array(1).keys()].map((index) => (
                <Text
                  key={index}
                  style={{
                    flexShrink: 1,
                    color: "#F2D379",
                    width: Platform.OS === "web" ? 300 : 250,
                  }}
                >
                  JavaScript
                </Text>
              ))}
            </MarkedList>
            <MarkedList counterRenderer={disc}>
              {[...Array(1).keys()].map((index) => (
                <Text
                  key={index}
                  style={{
                    flexShrink: 1,
                    color: "#F2D379",
                    width: Platform.OS === "web" ? 300 : 250,
                  }}
                >
                  Redux
                </Text>
              ))}
            </MarkedList>
            <MarkedList counterRenderer={disc}>
              {[...Array(1).keys()].map((index) => (
                <Text
                  key={index}
                  style={{
                    flexShrink: 1,
                    color: "#F2D379",
                    width: Platform.OS === "web" ? 300 : 250,
                  }}
                >
                  TypeScript
                </Text>
              ))}
            </MarkedList>
          </ScrollView>
        </Text>

        <View style={styles.experienceWrapper}>
          <Text style={styles.paragraph2}>PayNearMe/Santa Clara, CA</Text>
          <Text style={styles.paragraph1}>Staff Accountant</Text>
          <Text style={styles.paragraph3}> Feb 2018 – sep 2021</Text>
        </View>
        <Text style={styles.paragraph4}>
          {`Prepared financial statements as well as analysis of financial information that aids in making better decisions for executives and management. 

            `}
          <ScrollView style={styles.scrollView}>
            <MarkedList counterRenderer={disc}>
              {[...Array(1).keys()].map((index) => (
                <Text
                  key={index}
                  style={{
                    flexShrink: 1,
                    color: "#F2D379",
                    width: Platform.OS === "web" ? 300 : 250,
                  }}
                >
                  General ledger & bank reconciliation
                </Text>
              ))}
            </MarkedList>
            <MarkedList counterRenderer={disc}>
              {[...Array(1).keys()].map((index) => (
                <Text
                  key={index}
                  style={{
                    flexShrink: 1,
                    color: "#F2D379",
                    width: Platform.OS === "web" ? 300 : 250,
                  }}
                >
                  Prepare annual 1099 filling
                </Text>
              ))}
            </MarkedList>
            <MarkedList counterRenderer={disc}>
              {[...Array(1).keys()].map((index) => (
                <Text
                  key={index}
                  style={{
                    flexShrink: 1,
                    color: "#F2D379",
                    width: Platform.OS === "web" ? 300 : 250,
                  }}
                >
                  Support External Auidit
                </Text>
              ))}
            </MarkedList>
          </ScrollView>
        </Text>
        </ScrollView>
      </ImageBackground>
    </SafeAreaView>
  );
}
const styles = StyleSheet.create({
  container: {
    flex: 1,
    alignItems: "center",
    backgroundColor: "#041e2a",
    justifyContent: "center",
  },
  image: {
    flex: 1,
    width: "100%",
    height: "100%",
    flexDirection: "column",
  },

  p1: {
    alignSelf: "center",
    marginTop: 24,
    color: "#7df7cb",
    fontSize: 30,
    fontWeight: Platform.OS === "web" ? "bold" : null,
    fontFamily: "Limelight_400Regular",
  },
  paragraph1: {
    alignSelf: "center",
    color: "white",
    fontSize: 13,
    fontStyle: "italic",
    color: "#000",
  },
  paragraph2: {
    alignItems: "center",
    marginTop: 2,
    color: "#000",
    fontSize: 15,
  },
  paragraph3: {
    alignSelf: "center",
    marginTop: 2,
    color: "#000",
    fontSize: 13,
  },
  paragraph4: {
    alignSelf: "center",
    marginTop: 10,
    flexWrap: "wrap",
    maxWidth: Platform.OS === "web" ? 600 : 360,
    color: "#ffffff",
    padding: 10,
    backgroundColor: "#0f4a95d4",
    opacity: Platform.OS !== "web" ? 0.8 : 0.9,
    borderRadius: 15,
  },
  experienceWrapper: {
    alignSelf: "center",
    flexWrap: "wrap",
    maxWidth: Platform.OS === "web" ? 600 : 360,
    width:"100%",
    padding: 10,
    backgroundColor: "#d7c5c5",
    opacity: 0.9,
    borderRadius: 15,
    marginTop: 15,
    alignItems: "center",
    marginBottom:15,

    
    
    shadowColor: "#ff1a1a",
    
shadowOffset: {
	width: 0,
	height: 12,
},
shadowOpacity: 0.58,
shadowRadius: 16.00,

elevation: 24,





  },
  // scrollView:{
  //  margin:Platform.OS==='web'?'auto':null,
  //  marginLeft:Platform.OS!=='web'? 50:null,
  //   maxWidth:Platform.OS==='web'? 600:100,

  // }
});
